// extracted by mini-css-extract-plugin
module.exports = {"colorPrimaryMain":"#ff8300","colorSecondaryMain":"#1890ff","colorLayoutWhite":"#fff","colorLayoutDivider":"#d8d8d8","colorNeutralLighter":"#bfbfbf"};